import React from "react";
import { IFreeTextQuestion } from "../../constants/types";
import { sortByQuestionOrder } from "../../helpers/sortByQuestionOrder";

import { Grid } from "../../UI/Grid";

import { FreeTextQuestion } from "./FreeTextQuestion";

interface IProps {
  questions?: IFreeTextQuestion[];
}

export const UserFreeTextQuestions: React.FC<IProps> = (props) => (
  <Grid container>
    {sortByQuestionOrder(props.questions as IFreeTextQuestion[]).map((question: any) => (
      <Grid
        item
        px={3}
        xs={12}
        key={question.questionId}
        sx={{
          borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
          "&:last-child": {
            border: 0,
          },
        }}
      >
        <FreeTextQuestion {...question} />
      </Grid>
    ))}
  </Grid>
);

UserFreeTextQuestions.defaultProps = {
  questions: [],
};
